export default __webpack_public_path__ + "static/leaf-gray-76ba65efa8f7ef703e64fbfc7c2fa788.png";